export const columnProductList = [
  {
    key: "product_main_image",
    label: "Product",
    filter: false,
    sorter: false
  },
  {
    key: "name",
    label: "Product Title",
    filter: false,
    sorter: false,
  },
  {
    key: "category_name",
    label: "Category",
    filter: false,
    sorter: false
  },
  {
    key: "brand_name",
    label: "Brand",
    filter: false,
    sorter: false
  },
  {
    key: "sku",
    label: "SKU",
    filter: false,
    sorter: false
  },
  {
    key: "qty",
    label: "Stock",
    filter: false,
    sorter: false,
  },
  {
    key: "price",
    label: "Unit Price",
    filter: false,
    sorter: false
  },
  {
    key: "status",
    label: "Status",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Date Added",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnCategoryList = [
  {
    key: "name",
    label: "Category Name",
    filter: false,
    sorter: false
  },
  {
    key: "sub_category_count",
    label: "Sub Category",
    filter: false,
    sorter: false,
  },
  {
    key: "description",
    label: "Category Description",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Date Added",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnSubCategoryList = [
  {
    key: "name",
    label: "Sub Category",
    filter: false,
    sorter: false
  },
  {
    key: "category_name",
    label: "Parent Category",
    filter: false,
    sorter: false,
  },
  {
    key: "description",
    label: "Sub Category Description",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Date Added",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnBrandList = [
  {
    key: "name",
    label: "Brand Name",
    filter: false,
    sorter: false
  },
  {
    key: "brand_uuid",
    label: "Brand ID",
    filter: false,
    sorter: false,
  },
  {
    key: "total_products",
    label: "Total Products",
    filter: false,
    sorter: false
  },
  {
    key: "total_sales",
    label: "Total Sales",
    filter: false,
    sorter: false
  },
  {
    key: "person_in_charge",
    label: "Brand PIC",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Date Registered",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnOrderList = [
  {
    key: "transaction_id",
    label: "Order ID",
    filter: false,
    sorter: false,
  },
  {
    key: "customer_name",
    label: "Customer Name",
    filter: false,
    sorter: false
  },
  {
    key: "transaction_date",
    label: "Purchase Date / Time",
    filter: false,
    sorter: false
  },
  {
    key: "transaction_amount",
    label: "Amount Purchase",
    filter: false,
    sorter: false
  },
  {
    key: "payment_type",
    label: "Payment Type",
    filter: false,
    sorter: false
  },
  {
    key: "shipping_company",
    label: "Shipping Method",
    filter: false,
    sorter: false
  },
  {
    key: "payment_status",
    label: "Status",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnCustomerList = [
  {
    key: "customer_id",
    label: "Customer No.",
    filter: false,
    sorter: false,
  },
  {
    key: "full_name",
    label: "Customer Name",
    filter: false,
    sorter: false
  },
  {
    key: "email",
    label: "Email Address",
    filter: false,
    sorter: false
  },
  {
    key: "phone_number",
    label: "Phone Number",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Registered On",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];

export const columnCouponList = [
  {
    key: "promo_uuid",
    label: "Coupon ID",
    filter: false,
    sorter: false,
  },
  {
    key: "title",
    label: "Coupon Name",
    filter: false,
    sorter: false
  },
  {
    key: "promo_type",
    label: "Coupon Type",
    filter: false,
    sorter: false
  },
  {
    key: "promo_code",
    label: "Coupon Code",
    filter: false,
    sorter: false
  },
  {
    key: "quota",
    label: "Quota",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Created On",
    filter: false,
    sorter: false
  },
  // {
  //   key: "action",
  //   label: "",
  //   filter: false,
  //   sorter: false
  // },
];
